import i18next from 'i18next';

import {useRestMutation} from '@famly/stat_apollo-query';
import type {
    DeletePlanMutationResult,
    DeletePlanMutationVariables,
} from 'web-app/api/clients/rest-types/delete-plan/delete-plan';
import * as GlobalEvent from 'web-app/services/global-event';

import {DeletePlan} from '../../queries/delete-plan.rest-mutation';

type Result = {
    deletePlan: VoidFunction;
};

type Args = {
    planId: string;
    afterDeletion: VoidFunction;
};

type UseDeletePlan = (args: Args) => Result;

export const useDeletePlan: UseDeletePlan = ({planId, afterDeletion}) => {
    const [deletePlanMutation] = useRestMutation<DeletePlanMutationResult, DeletePlanMutationVariables>(DeletePlan);

    const deletePlan = () => {
        return deletePlanMutation({
            variables: {
                planId,
            },
            onCompleted: () => {
                afterDeletion();
                GlobalEvent.updateSuccess(
                    i18next.t('react.simplifiedUsBillingPlan.translations.json.deletePlan.planDeleted'),
                );
            },
        });
    };

    return {deletePlan};
};
